"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var Variables_1 = require("../Variables");
var getCssValue = function (key, value) {
    if (value === 'none') {
        return "".concat(key, ": 'none';");
    }
    else if (value && Variables_1.margin[value]) {
        return "".concat(key, ": ").concat(Variables_1.margin[value], ";");
    }
    else {
        return '';
    }
};
exports.default = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var margin = _a.margin;
    return getCssValue('margin', margin);
}, function (_a) {
    var marginTop = _a.marginTop;
    return getCssValue('margin-top', marginTop);
}, function (_a) {
    var marginBottom = _a.marginBottom;
    return getCssValue('margin-bottom', marginBottom);
}, function (_a) {
    var marginLeft = _a.marginLeft;
    return getCssValue('margin-left', marginLeft);
}, function (_a) {
    var marginRight = _a.marginRight;
    return getCssValue('margin-right', marginRight);
}, function (_a) {
    var marginVertical = _a.marginVertical;
    return getCssValue('margin-top', marginVertical) + getCssValue('margin-bottom', marginVertical);
}, function (_a) {
    var marginHorizontal = _a.marginHorizontal;
    return getCssValue('margin-left', marginHorizontal) + getCssValue('margin-right', marginHorizontal);
});
var templateObject_1;
